import React from 'react'
import { Box, Typography } from '@mui/material'
const LeadSummry = ({details}) => {
    const LeadSummaryDetails = [
        {
            Title: 'Time On Site',
            Time:details?.timeOnSite || 0
        },
        {
            Title: 'Pages Viewed',
            Time: details?.pagesViewed || 0
        },
        {
            Title: 'Return Visits',
            Time: details?.returnVisit ? details?.returnVisit-1 : 0
        },
    ]
    return (
        <>
            <Box sx={{ background: '#fff', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px;', padding: '25px', borderRadius: '16px', marginBottom: '25px' }}>
                <Box>
                    <Typography variant='h2' sx={{ color: '#1E1E1E', fontSize: {xl: '24px !important' , lg: '17px !important'}, marginBottom: '20px', fontWeight: '500' }}>Lead Summary</Typography>
                </Box>
                <Box>
                    {
                        LeadSummaryDetails.map(item => (

                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '9px' }}>
                                <Typography sx={{ color: '#1E1E1E',  fontSize: {xl: '18px !important' , lg: '14px !important'}, fontWeight: '500' }}>{item.Title}</Typography>
                                <Typography sx={{ color: '#5A5A5A', fontSize: {xl: '16px !important' , lg: '12px !important'}, fontWeight: '400' }}>{item.Time}</Typography>
                            </Box>
                        ))
                    }
                </Box>
            </Box>
        </>
    )
}

export default LeadSummry